<template>
  <div
    class="m-badge"
    :class="{
      [`m-badge--${size}`]: size,
      'm-badge--corner': corner,
      [`m-badge--${skin}`]: skin,
    }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'MBadge',
  props: {
    /**
     * Change the size of the badge
     */
    size: {
      type: String,
      default: 'medium',
      validator: (prop) => ['small', 'medium', 'large', 'xl'].includes(prop),
    },
    /**
     * Absolutely position the badge in the top right corner of it's relatively positioned parent
     */
    corner: {
      type: Boolean,
      default: false,
    },
    // Todo: deprecate and replace with MSkin support
    /**
     * The color of the badge
     */
    skin: {
      type: String,
      default: 'highlight',
      validator: (prop) => ['highlight', 'dark'].includes(prop),
    },
  },
}
</script>

<style scoped lang="scss">
$badge-size-sm: 16px;
$badge-size-md: 24px;
$badge-size-lg: 32px;
$badge-size-xl: 48px;
.m-badge {
  align-items: center;
  border-radius: 50%;
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  pointer-events: none;

  &--highlight {
    background-color: var(--color-secondary-regular);
    color: var(--color-text-body-dark);
  }

  &--dark {
    background: var(--skin-background-dark);
    color: var(--skin-color-dark);
  }

  &--small {
    font-size: var(--typography-paragraph-micro-font-size);
    height: $badge-size-sm;
    min-width: $badge-size-sm;
    width: $badge-size-sm;
  }
  &--medium {
    font-size: var(--typography-paragraph-small-font-size);
    height: $badge-size-md;
    min-width: $badge-size-md;
    width: $badge-size-md;
  }
  &--large {
    font-size: var(--typography-paragraph-regular-font-size);
    height: $badge-size-lg;
    min-width: $badge-size-lg;
    width: $badge-size-lg;
  }
  &--xl {
    font-size: var(--typography-paragraph-large-font-size);
    height: $badge-size-xl;
    min-width: $badge-size-xl;
    width: $badge-size-xl;
  }
  &--corner {
    position: absolute;
    &.m-badge--small {
      right: -8px;
      top: -10px;
    }
    &.m-badge--medium {
      right: -7px;
      top: -7px;
    }
  }
}
</style>
